import classNames from 'classnames';

import Button from '@components/atoms/Button';
import FilePreview, { Props as FilePreviewProps } from '@components/FilePreview';
import { FormattedMessage } from 'utils/intl';

import classes from './StpFilePreview.module.scss';
import messages from './StpFilePreview.messages';

type Props = Omit<FilePreviewProps, 'fileType' | 'preview'>;

const StpFilePreview = ({
  additionalButton,
  classes: customClasses,
  fileName,
  fileUrl,
  downloadFileName,
  headerComponent,
  onClose,
}: Props): JSX.Element => (
  <FilePreview
    fileType="STP"
    fileName={fileName}
    fileUrl={fileUrl}
    downloadFileName={downloadFileName}
    classes={customClasses}
    downloadMessage={<FormattedMessage {...messages.download} />}
    headerComponent={headerComponent}
    additionalButton={additionalButton}
    preview={({ onDownload }) => (
      <div className={classNames(classes.wrapper, customClasses?.object)}>
        <Button color="quaternary" variant="outlined" shape="round" size="lg" onClick={onClose}>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button color="tertiary" shape="round" size="lg" onClick={onDownload}>
          <FormattedMessage {...messages.download} />
        </Button>
      </div>
    )}
  />
);

export default StpFilePreview;
